import { render, staticRenderFns } from "./Recipients.vue?vue&type=template&id=6fa511d3&scoped=true&"
import script from "./Recipients.vue?vue&type=script&lang=js&"
export * from "./Recipients.vue?vue&type=script&lang=js&"
import style0 from "./Recipients.vue?vue&type=style&index=0&id=6fa511d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa511d3",
  null
  
)

export default component.exports